import { FundOpportunityWithInvestor } from './contactFundOpportunityKanbanTypes';

export function matchesPipelineStage(
  investor: NonNullable<FundOpportunityWithInvestor['investor']>,
  stage: string,
): boolean {
  if (stage === 'LEAD') {
    return investor.status === 'LEAD' && !investor.eoiSubmitted;
  }
  if (stage === 'LEAD_WITH_EOI') {
    return investor.status === 'LEAD' && Boolean(investor.eoiSubmitted);
  }
  return investor.status === stage;
}

export function filterOpportunitiesForStage(
  opportunities: FundOpportunityWithInvestor[],
  stage: string,
  opportunityFilter: string,
): FundOpportunityWithInvestor[] {
  let filtered = opportunities.filter((opportunity) => {
    const investor = opportunity.investor;
    if (!investor) {
      return false;
    }
    return matchesPipelineStage(investor, stage);
  });

  if (opportunityFilter) {
    const filterLower = opportunityFilter.toLowerCase();
    filtered = filtered.filter((opportunity) => {
      return (
        (opportunity.name && opportunity.name.toLowerCase().includes(filterLower)) ||
        (opportunity.investor?.status &&
          String(opportunity.investor.status).toLowerCase().includes(filterLower))
      );
    });
  }

  return filtered;
}
